import { ReactNode, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cns from 'classnames';
import { Button } from '../Button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay, DialogPanel, DialogTitle } from '../Dialog';
import S from './AlertDialog.module.scss';
export const AlertDialog = (props: AlertDialogProps) => {
  const {
    maxWidth = '320px',
    topSlot,
    title,
    content,
    dimmed = true,
    keyboard = true,
    useOutSideClick = false,
    confirmText,
    focus,
    onClose,
    onConfirm,
    ...rest
  } = props;
  const {
    t
  } = useTranslation(['common']);
  const handleClose = () => {
    if (!useOutSideClick) {
      return;
    }
    onClose && onClose();
  };
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    // props 로 제어하고 싶을때만 준다. (복수개 인케이스)
    if (focus && buttonRef.current) {
      buttonRef?.current.focus();
    }
  }, [focus]);
  return <Dialog maxWidth={maxWidth} open onClose={handleClose} initialFocus={buttonRef} onKeyDown={e => !keyboard && e.stopPropagation()} {...rest} data-sentry-element="Dialog" data-sentry-component="AlertDialog" data-sentry-source-file="AlertDialog.tsx">
      {dimmed && <DialogOverlay />}
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="AlertDialog.tsx">
        <DialogHeader topSlot={topSlot} className={cns(!content && S.header)} data-sentry-element="DialogHeader" data-sentry-source-file="AlertDialog.tsx">
          <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="AlertDialog.tsx">{title}</DialogTitle>
        </DialogHeader>
        {content && <DialogContent preLine>{content}</DialogContent>}
        <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="AlertDialog.tsx">
          <Button ref={buttonRef} size="md" onClick={onConfirm} data-sentry-element="Button" data-sentry-source-file="AlertDialog.tsx">
            {confirmText ?? t('common:confirm')}
          </Button>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export type AlertDialogProps = {
  maxWidth?: string;
  topSlot?: ReactNode;
  title: ReactNode;
  content?: ReactNode;
  dimmed?: boolean;
  keyboard?: boolean;
  useOutSideClick?: boolean;
  confirmText?: ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
  focus?: boolean;
};